var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImmigrationTravelicons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4368 10.0234L14.3376 15.4323C14.4408 16.0517 14.2385 16.6828 13.7945 17.1268L12.8007 18.1207L10.9857 12.3362",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56204 8.946L1.82343 7.14544L2.81731 6.15155C3.26134 5.70755 3.8924 5.5053 4.51179 5.60849L9.92068 6.50933",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5951 5.13195L15.5512 4.96945C15.4735 4.68129 15.2499 4.45526 14.9626 4.37445L14.8018 4.33029C14.2989 4.14956 13.7372 4.26467 13.3459 4.62862L5.33121 12.6308L3.57037 12.397L2.11121 13.8725L4.87898 15.067L6.02262 17.902L7.51457 16.3942L7.30707 14.6086L15.3071 6.61001C15.6661 6.20704 15.7765 5.64026 15.5951 5.13195Z",
    stroke: "#fff",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImmigrationTravelicons);
export default __webpack_public_path__ + "static/media/ImmigrationTravelicons.a4802eba62bf1899e5d61b745a3161d6.svg";
export { ForwardRef as ReactComponent };